"use strict";

var _interopRequireWildcard = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

require("D:\\a2\\Code_New\\Web\\node_modules\\core-js\\modules\\es6.array.iterator.js");

require("D:\\a2\\Code_New\\Web\\node_modules\\core-js\\modules\\es6.promise.js");

require("D:\\a2\\Code_New\\Web\\node_modules\\core-js\\modules\\es6.object.assign.js");

require("D:\\a2\\Code_New\\Web\\node_modules\\core-js\\modules\\es7.promise.finally.js");

var _vue = _interopRequireDefault(require("vue"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

require("normalize.css/normalize.css");

var _elementUi = _interopRequireDefault(require("element-ui"));

require("./styles/element-variables.scss");

require("@/styles/index.scss");

var _App = _interopRequireDefault(require("./App"));

var _store = _interopRequireDefault(require("./store"));

var _router = _interopRequireDefault(require("./router"));

var _moment = _interopRequireDefault(require("moment"));

require("./icons");

require("./permission");

var filters = _interopRequireWildcard(require("./filters"));

var _index2 = _interopRequireDefault(require("@/directive/permission/index.js"));

var _vueTableWithTreeGrid = _interopRequireDefault(require("vue-table-with-tree-grid"));

// A modern alternative to CSS resets
// global css
// icon
// permission control
// global filters
// 权限判断指令
//时间轴控件
// import LightTimeline from 'vue-light-timeline';
// Vue.use(LightTimeline);
//打印
// import Print from '@/utils/print'
// Vue.use(Print)
_vue.default.directive('removeAriaHidden', {
  bind: function bind(el, binding) {
    var ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach(function (item) {
      item.removeAttribute('aria-hidden');
    });
  }
}); //避免按钮双击操作 默认1秒


_vue.default.directive('preventReClick', {
  inserted: function inserted(el, binding) {
    el.addEventListener('click', function () {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(function () {
          el.disabled = false;
        }, binding.value || 1000);
      }
    });
  }
});

_vue.default.use(_vueTableWithTreeGrid.default);

_elementUi.default.Table.props.stripe = {
  type: Boolean,
  default: true
};

_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('size') || 'mini' // set element-ui default size

});

_vue.default.directive('permission', _index2.default); //判空


_vue.default.prototype.isEmptyObjVue = function (obj) {
  if (obj == null || obj == undefined || "" + obj == "") {
    return true;
  }

  return false;
}; //时间格式统一处理


_vue.default.prototype.formateDate = function (date) {
  if (_vue.default.prototype.isEmptyObjVue(date)) {
    return '';
  }

  return (0, _moment.default)(date).format('YYYY-MM-DD HH:mm:ss');
};

_vue.default.prototype.formateDay = function (date) {
  if (_vue.default.prototype.isEmptyObjVue(date)) {
    return '';
  }

  return (0, _moment.default)(date).format('YYYY-MM-DD');
};

_vue.default.prototype.dateFormatA = function (row, column) {
  var date = row[column.property];

  if (_vue.default.prototype.isEmptyObjVue(date)) {
    return '';
  }

  return (0, _moment.default)(date).format('YYYY-MM-DD HH:mm');
};

_vue.default.prototype.formatMinute = function (duration) {
  if (!duration) return "00分00秒";
  var day = parseInt(duration / (60 * 60 * 24));
  var h = parseInt(duration % (60 * 60 * 24) / (60 * 60));
  var m = parseInt((duration - h * 60 * 60 - day * (60 * 60 * 24)) / 60);
  var s = parseInt(duration % 60);
  h = h.toString().length < 2 ? "0" + h.toString() : h.toString();
  m = m.toString().length < 2 ? "0" + m.toString() : m.toString();
  s = s.toString().length < 2 ? "0" + s.toString() : s.toString();
  return h + '小时' + m.toString() + '分' + s.toString() + '秒';
}; // register global utility filters.


Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;
new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  render: function render(h) {
    return h(_App.default);
  }
});